module.exports = __webpack_public_path__ + "static/media/aep_white@2x.b218d80a.png";